/**
 * An array representing different company size categories based on the number of employees.
 */
export const companySizes = {
  es: [
    '0-1 empleados',
    '2-10 empleados',
    '11-20 empleados',
    '21-50 empleados',
    '51-100 empleados',
    '101-500 empleados',
    '501-1000 empleados',
    '1001-5000 empleados',
    '5001-10.000 empleados',
    'Más de 10.000 empleados',
  ],
  en: [
    '0-1 employees',
    '2-10 employees',
    '11-20 employees',
    '21-50 employees',
    '51-100 employees',
    '101-500 employees',
    '501-1000 employees',
    '1001-5000 employees',
    '5001-10.000 employees',
    'More than 10.000 employees',
  ],
};

/**
 * Constructs an object mapping company size descriptions to their corresponding
 * numeric ranges for both Spanish and English.
 */
export const companySizeValue = {
  ...Object.fromEntries(
    companySizes.es.map((size) => [
      size,
      size.replace(' empleados', '').replace('Más de ', '>').replace('.', ''),
    ])
  ),
  ...Object.fromEntries(
    companySizes.en.map((size) => [
      size,
      size
        .replace(' employees', '')
        .replace('More than ', '>')
        .replace('.', ''),
    ])
  ),
};

/**
 * Maps course names to their corresponding internal identifiers.
 * This mapping includes both English and Spanish course names.
 */
export const courseValueMapping = {
  'Herramientas de Productividad': 'productivity_boosters',
  'Herramientas de Comunicación': 'communication_boosters',
  'Herramientas de Equipo': 'team_boosters',
  'Herramientas de Innovación': 'innovation_boosters',
  'Herramientas de Reunión': 'meeting_boosters',
  'Herramientas de Estrategia': 'strategy_boosters',
  'Sesiones Personalizadas': 'personalized_sessions',

  'Productivity Boosters': 'productivity_boosters',
  'Communication Boosters': 'communication_boosters',
  'Team Boosters': 'team_boosters',
  'Innovation Boosters': 'innovation_boosters',
  'Meeting Boosters': 'meeting_boosters',
  'Strategy Boosters': 'strategy_boosters',
  'Personalized Sessions': 'personalized_sessions',
};

/**
 * An object containing error messages for various HTTP status codes.
 * Each status code maps to an array of messages, with the first message
 * in Spanish and the second in English. The 'default' key provides a
 * generic error message for unexpected errors.
 */
export const errorOnSubscriptionMessages = {
  400: ['Error en los datos introducidos', 'Invalid data provided'],
  409: [
    '¡Ya te has inscrito al newsletter! Paciencia... 😉',
    'You have already signed up for the newsletter! Patience… 😉',
  ],
  401: [
    'Por favor, vuelve a verificar que eres humano',
    'Please, verify that you are human again',
  ],
  default: [
    'Ha sucedido un error inesperado. Por favor, inténtalo más tarde',
    'An unexpected error occurred. Please try again later',
  ],
};
